import { FormStore, GlobalStore } from '@roc/feature-app-core';

// Mirrors libs/feature-lien/src/store/lienFormStore.ts (Title Commitment's manual Add/Edit
// lien form) - duplicated locally rather than imported, since importing @roc/feature-lien
// here would introduce a real circular dependency (feature-lien -> feature-app-core ->
// feature-borrowers -> feature-documents -> feature-lien-payoff). Both forms edit the same
// property_liens fields; keep them in sync if one changes. Only the amount is required; lien type,
// borrower, lender and dates get filled in later from the payoff letter or Title Commitment.
const form = {
  fields: {
    lienType: {
      value: '',
      error: null,
      rule: '',
      label: 'Lien Type',
      attribute: 'Lien Type',
    },
    madeBy: {
      value: '',
      error: null,
      rule: '',
      label: 'Borrower',
      attribute: 'Borrower',
    },
    madeTo: {
      value: '',
      error: null,
      rule: '',
      label: 'Lender',
      attribute: 'Lender',
    },
    datedDate: {
      value: '',
      error: null,
      rule: '',
      label: 'Dated',
      attribute: 'Dated',
    },
    recordedDate: {
      value: '',
      error: null,
      rule: '',
      label: 'Recorded',
      attribute: 'Recorded',
    },
    originalAmount: {
      value: '',
      error: null,
      rule: 'required',
      label: 'Amount',
      attribute: 'Amount',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export const LIEN_TYPE_OPTIONS = [
  { label: 'Please Select', value: '' },
  { label: 'Deed of Trust', value: 'Deed of Trust' },
  { label: 'Mortgage', value: 'Mortgage' },
  { label: 'UCC', value: 'UCC' },
  { label: 'Judgment', value: 'Judgment' },
  { label: 'Assessment Lien', value: 'Assessment Lien' },
  { label: 'Tax Lien', value: 'Tax Lien' },
  { label: "Mechanic's Lien", value: "Mechanic's Lien" },
];

export class LienFormStore extends FormStore {
  constructor(globalStore: GlobalStore) {
    super(form, globalStore);
  }
}
